"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lodash_1 = require("lodash");

var cut_outs_1 = require("../cut-outs");

var create_error_1 = require("./create-error");

var dimensions_1 = require("../dimensions");

var validation_utils_1 = require("./validation.utils");

exports.validateTapHole = function (builtInParts, defaults, props) {
  var error = undefined;

  if (builtInParts && builtInParts.tapHole && !props.drillHoleAtBackEnabled) {
    // Drill holes positions should be placed at the LEFT or RIGHT side oa a trough.
    var tapHolePositions = validation_utils_1.prepareLeftRightPositions({
      partPositions: props.qty === props.prevQty && builtInParts.tapHole && builtInParts.tapHolePositions || [],
      qty: props.qty,
      prevQty: props.prevQty,
      defaultPosition: 'left'
    });

    if (tapHolePositions && tapHolePositions.positions && tapHolePositions.positions.length > 0) {
      if (!props.plateBuilder) {
        error = create_error_1.createError({
          msg: "Platebuilder not provided.",
          code: 'NOT_ASSIGNABLE',
          inObject: 'builtInParts.cutOutDisposalsType',
          statusCode: 400
        });
        return error;
      }

      defaults.tapHolePositions.values = tapHolePositions.positions;
      defaults.tapHolePositions.isEnabled = [];
      var isDrillHoleAllowed_1 = []; // const soapDispenserHoleIsEnabled = !props.drillHoleAtBackEnabled && builtInParts.soapDispenserHole !== 'without' ? true : false;

      var soapDispenserHolePositions_1 = builtInParts.soapDispenserHolePositions; // (tapHolePositions.positions as LEFT_RIGHT[]).forEach(() => isDrillHoleAllowed.push({left: true, right: true}));

      defaults.tapHolePositions.values.forEach(function (position, index) {
        var soapPosition = soapDispenserHolePositions_1 && soapDispenserHolePositions_1[index];
        isDrillHoleAllowed_1[index] = {
          left: true,
          right: true // soapDispenserHoleIsEnabled && soapPosition === 'right' ? false : true,

        };

        if (soapPosition && soapPosition === position) {
          defaults.tapHolePositions.isEnabled.push(false);
          defaults.tapHolePositions.values[index] = soapPosition === 'left' ? 'right' : 'left';
        } else {
          defaults.tapHolePositions.isEnabled.push(true);
        }
      });
      defaults.tapHolePositions.isDrillHoleAllowed = isDrillHoleAllowed_1;
      defaults.tapHolePositions.values.forEach(function (position, index) {
        var trough = props.plateBuilder.components.elements.filter(function (e) {
          return e.type === 'trough' && e.troughIndex === index;
        })[0];
        var tap = props.plateBuilder.elementsBuilder.buildTap({
          troughIndex: index
        }, true); // const spacing = (props.plateBuilder as PlateBuilder).calc.spaceAroundElement(trough, (props.plateBuilder as PlateBuilder).components.elements, ['angle-bar', 'console', 'spacer', 'safety-catch'], true);

        var spacing = props.plateBuilder.calc.spaceAroundElement(trough, undefined, undefined, tap); // spaceAroundElement has to accept a forElement which it should ignore

        var reqWidth = tap.outerWidth;
        var isAllowed = defaults.tapHolePositions.isDrillHoleAllowed[index]; // console.log('TAPYEE', tap, spacing, reqWidth);

        if (isAllowed.left) {
          defaults.tapHolePositions.isDrillHoleAllowed[index].left = spacing.left && spacing.left >= reqWidth ? true : false;
        }

        if (isAllowed.right) {
          defaults.tapHolePositions.isDrillHoleAllowed[index].right = spacing.right && spacing.right >= reqWidth ? true : false;
        }
      });
      return error ? error : defaults;
    }
  }

  defaults.tapHolePositions = {
    default: null,
    isEnabled: [],
    isDrillHoleAllowed: [],
    values: []
  };
  return error ? error : defaults;
};

exports.validateSoapDispenser = function (builtInParts, defaults, props) {
  var error = undefined;

  if (builtInParts && builtInParts.soapDispenserHole && builtInParts.soapDispenserHole !== 'without') {
    var soapDispenserHolePositions = validation_utils_1.prepareLeftRightPositions({
      partPositions: props.qty === props.prevQty && builtInParts.soapDispenserHolePositions || [],
      qty: props.qty,
      prevQty: props.prevQty,
      defaultPosition: 'right'
    });

    if (soapDispenserHolePositions && soapDispenserHolePositions.positions && soapDispenserHolePositions.positions.length > 0) {
      if (!props.plateBuilder) {
        error = create_error_1.createError({
          msg: "Platebuilder not provided.",
          code: 'NOT_ASSIGNABLE',
          inObject: 'builtInParts.cutOutDisposalsType',
          statusCode: 400
        });
        return error;
      }

      defaults.soapDispenserHolePositions.values = soapDispenserHolePositions.positions;
      defaults.soapDispenserHolePositions.isEnabled = [];
      var isDrillHoleAllowed_2 = []; // const tapHoleIsEnabled = !props.drillHoleAtBackEnabled && builtInParts.tapHole ? true : false;

      var tapHolePositions_1 = builtInParts.tapHolePositions;
      soapDispenserHolePositions.positions.forEach(function (position, index) {
        var tapHolePosition = tapHolePositions_1 && tapHolePositions_1[index];
        isDrillHoleAllowed_2[index] = {
          left: true,
          right: true // props.drillHoleAtBackEnabled ? true : tapHoleIsEnabled && tapHolePosition === 'right' ? false : true,

        };

        if (tapHolePosition && tapHolePosition === position) {
          defaults.soapDispenserHolePositions.isEnabled.push(false); // defaults.soapDispenserHolePositions.values[index] = tapHolePosition === 'left' ? 'right' : 'left';
        } else {
          defaults.soapDispenserHolePositions.isEnabled.push(true);
        }
      });
      defaults.soapDispenserHolePositions.isDrillHoleAllowed = isDrillHoleAllowed_2;
      soapDispenserHolePositions.positions.forEach(function (position, index) {
        var trough = props.plateBuilder.components.elements.filter(function (e) {
          return e.type === 'trough' && e.troughIndex === index;
        })[0];
        var soapDispenser = props.plateBuilder.elementsBuilder.buildSoapDispenser({
          troughIndex: index
        }, builtInParts.soapDispenserHole, true);
        var spacing = props.plateBuilder.calc.spaceAroundElement(trough, props.plateBuilder.components.elements, ['angle-bar', 'console', 'spacer', 'safety-catch', 'tap'], soapDispenser);
        var reqWidth = soapDispenser.outerWidth;
        var isAllowed = defaults.soapDispenserHolePositions.isDrillHoleAllowed[index];
        var drillHoleAtBackEnabled = props.drillHoleAtBackEnabled; // console.log('SDDD', spacing, reqWidth);

        if (isAllowed.left) {
          defaults.soapDispenserHolePositions.isDrillHoleAllowed[index].left = drillHoleAtBackEnabled || spacing.left && spacing.left >= reqWidth ? true : false;
        }

        if (isAllowed.right) {
          defaults.soapDispenserHolePositions.isDrillHoleAllowed[index].right = drillHoleAtBackEnabled || spacing.right && spacing.right >= reqWidth ? true : false;
        }
      });
      return error ? error : defaults;
    }
  }

  defaults.soapDispenserHolePositions = {
    default: null,
    isEnabled: [],
    isDrillHoleAllowed: [],
    values: []
  };
  return error ? error : defaults;
};

exports.validateCutOutDisposalsType = function (builtInParts, defaults, consoles, plateBuilder, apronHeight, conf) {
  var error;

  if (builtInParts.cutOutDisposals === false) {
    if (builtInParts.cutOutDisposalsType && builtInParts.cutOutDisposalsType.length > 0) {
      error = create_error_1.createError({
        msg: "Can't assign any Position types for a cut out if it's set to false.",
        code: 'NOT_ASSIGNABLE',
        inObject: 'builtInParts.cutOutDisposalsType',
        statusCode: 400
      });
      return error;
    }
  }

  if (builtInParts && builtInParts.cutOutDisposalsPosition && builtInParts.cutOutDisposalsPosition.length > 0) {
    if (!plateBuilder) {
      error = create_error_1.createError({
        msg: "Platebuilder not provided.",
        code: 'NOT_ASSIGNABLE',
        inObject: 'builtInParts.cutOutDisposalsType',
        statusCode: 400
      });
      return error;
    }

    var cutOuts = cut_outs_1.cutOuts(conf);
    var isEnabled = []; // I have to loop through all of the spacings, then loop through the cutouts and add to isEnabled array if enough space...
    // I have to loop through the cutouts, for each one generate spacings...

    for (var i = 0; i < cutOuts.length; i++) {
      var cutOut = cutOuts[i];
      var cutoutElement = plateBuilder.elementsBuilder.buildCutOut({}, cutOut);
      var distances = plateBuilder.calc.spacePositions(cutoutElement, null, false);
      var spacings = plateBuilder.calc.spaceSizes(cutoutElement, distances);

      for (var ii = 0; ii < spacings.length; ii++) {
        var spacing = spacings[ii];

        if (typeof isEnabled[ii] === 'undefined') {
          isEnabled[ii] = [];
        }

        if (cutoutElement.outerWidth <= spacing) {
          isEnabled[ii].push(cutOut.key);
        }
      }
    } // const cutOutDisposalsType = builtInParts.cutOutDisposalsType;
    // const selectedType = _find(cutOuts, type => type.key === cutOutDisposalsType);


    defaults.cutOutDisposalsType = lodash_1.assign({}, defaults.cutOutDisposalsType, {
      isEnabled: isEnabled
    });
  }

  return error ? error : defaults;
};

exports.validateCutOutCustomSettings = function (builtInParts, defaults, consoles, plateBuilder, apronHeight) {
  var error;

  if (builtInParts.cutOutDisposals === false) {
    if (builtInParts.cutOutDisposalsCustomSettings) {
      error = create_error_1.createError({
        msg: "Can't assign any custom settings for a cut out if it's set to false.",
        code: 'NOT_ASSIGNABLE',
        inObject: 'builtInParts.cutOutDisposalsCustomSettings',
        statusCode: 400
      });
      return error;
    }
  }

  if (builtInParts && builtInParts.cutOutDisposalsCustomSettings) {
    if (!plateBuilder) {
      error = create_error_1.createError({
        msg: "Platebuilder not provided.",
        code: 'NOT_ASSIGNABLE',
        inObject: 'builtInParts.cutOutDisposalsCustomSettings',
        statusCode: 400
      });
      return error;
    } // Loop through the cutOutDisposalsCustomSettings...
    // Wait, what is the idea of validation?
    // I think it's to check if it's allowed, and update defaults (used for resetting?)

    /*
    const positionTypes = ;
    // Get all types at position...
    // If custom, then get it...
    const isEnabled: (CUT_OUT_TYPES | boolean)[][] = [];
         // I have to loop through all of the spacings, then loop through the cutouts and add to isEnabled array if enough space...
         // I have to loop through the cutouts, for each one generate spacings...
    for (let i = 0; i < cutOuts.length; i++) {
      const cutOut = cutOuts[i];
      const cutoutElement = plateBuilder.elementsBuilder.buildCutOut({}, cutOut);
      const distances = plateBuilder.calc.spacePositions(cutoutElement.outerWidth);
      const spacings = plateBuilder.calc.spaceSizes(cutoutElement, distances);
           for (let ii = 0; ii < spacings.length; ii++) {
        const spacing = spacings[ii];
        
        if (typeof isEnabled[ii] === 'undefined') { isEnabled[ii] = []; }
             if (cutoutElement.outerWidth < spacing) {
          isEnabled[ii].push(cutOut.key);
        }
      }
    }
    
    defaults.cutOutDisposalsCustomSettings = _assign({}, defaults.cutOutDisposalsCustomSettings, {
      values: values,
    });
    */

  }

  return error ? error : defaults;
};

exports.validateCutOutDisposalsPosition = function (builtInParts, defaults, consoles, apronBackSplash, plateBuilder, conf) {
  var error;

  if (builtInParts.cutOutDisposals === false) {
    if (builtInParts.cutOutDisposalsPosition && builtInParts.cutOutDisposalsPosition.length > 0) {
      error = create_error_1.createError({
        msg: "Can't assign any Position for a cut out if it's set to false.",
        code: 'NOT_ASSIGNABLE',
        inObject: 'builtInParts.cutOutDisposalsPosition',
        statusCode: 400
      });
      return error;
    }
  }

  if (builtInParts && builtInParts.cutOutDisposalsPosition && builtInParts.cutOutDisposalsPosition.length > 0) {
    if (!plateBuilder) {
      error = create_error_1.createError({
        msg: "Platebuilder not provided.",
        code: 'NOT_ASSIGNABLE',
        inObject: 'builtInParts.cutOutDisposalsPosition',
        statusCode: 400
      });
      return error;
    }

    var positions = builtInParts.cutOutDisposalsPosition;
    var cutOuts = cut_outs_1.cutOuts(conf);
    var isEnabled = [];

    var _loop_1 = function _loop_1(i) {
      var cutOutDisposalsType = builtInParts.cutOutDisposalsType;
      var selectedType_1 = lodash_1.find(cutOuts, function (type) {
        return type.key === cutOutDisposalsType;
      });

      if (!selectedType_1) {
        error = create_error_1.createError({
          msg: "Selected cutout not found.",
          code: 'NOT_ASSIGNABLE',
          inObject: 'builtInParts.cutOutDisposalsPosition',
          statusCode: 400
        });
        return {
          value: error
        };
      } // const consoleElement = plateBuilder.elementsBuilder.buildConsole();
      // if ((cutOutDisposalsType === 'CUSTOM_ROUND' || cutOutDisposalsType === 'CUSTOM_SQUARE') && (!builtInParts || !builtInParts.cutOutDisposalsCustomSettings)) { 
      //   selectedType.dimensions.width = 10;
      //   selectedType.dimensions.depth = 10;
      //   selectedType.reqDimensions.width = 10;
      //   selectedType.reqDimensions.depth = 10;
      // }


      var cutoutElement_1 = plateBuilder.elementsBuilder.buildCutOut({}, selectedType_1); // const distances = plateBuilder.calc.spacePositions(cutoutElement, null, false); // Previously was no outerwidth, but for some reason the calculation was less for this config - http://localhost:3300/configuration/633a5fce81801532488f3574/recesses - when meant could add a cutout

      var spacings_1 = plateBuilder.calc.spaceSizes(cutoutElement_1);

      if (positions.length !== spacings_1.length) {
        error = create_error_1.createError({
          msg: "Spacings and positions don't match.",
          code: 'NOT_ASSIGNABLE',
          inObject: 'builtInParts.cutOutDisposalsPosition',
          statusCode: 400
        });
      }

      var availableWidth = spacings_1[i];
      var hasWidth = availableWidth >= cutoutElement_1.outerWidth;
      var availableDepth = plateBuilder.components.plate.scale.z;
      var hasDepth = cutoutElement_1.scale.z + cutoutElement_1.buffer.front <= availableDepth;
      var apronHeight = apronBackSplash && apronBackSplash.apronHeight || 0;
      var reqApronMin = selectedType_1.reqDimensions.apron && selectedType_1.reqDimensions.apron.min || 0;
      var reqApronMax = selectedType_1.reqDimensions.apron && selectedType_1.reqDimensions.apron.max || dimensions_1.dimensions.defaultInputs.apronHeight.max;
      var hasApron = builtInParts.cutOutDisposalsApronRequired ? apronHeight >= reqApronMin && apronHeight <= reqApronMax : true; // console.log('validateCutOutDisposalsPosition', availableWidth, cutoutElement.outerWidth, cutoutElement);

      isEnabled.push(hasApron && hasWidth && hasDepth);
    }; // Calculate which spots are enabled/clickable...


    for (var i = 0; i < positions.length; i++) {
      var state_1 = _loop_1(i);

      if (typeof state_1 === "object") return state_1.value;
    }

    ; // Calculate spacings for cut-out available...

    var selectedType = lodash_1.find(cutOuts, function (type) {
      return type.key === 'FALLBACK';
    }) || cutOuts[0];
    var cutoutElement = plateBuilder.elementsBuilder.buildCutOut({}, selectedType);
    var distances = plateBuilder.calc.spacePositions(cutoutElement, null, false);
    var spacings = plateBuilder.calc.spaceSizes(cutoutElement);
    defaults.cutOutDisposalsPosition = lodash_1.assign({}, defaults.cutOutDisposalsPosition, {
      isEnabled: isEnabled,
      spacings: spacings,
      distances: distances
    });
  }

  return error ? error : defaults;
};

exports.validatePaperTowelDispensersPosition = function (builtInParts, defaults, consoles, plateBuilder, apronHeight, conf) {
  var error;

  if (builtInParts.tissueDispenser === false) {
    if (builtInParts.paperTowelDispensersPosition && builtInParts.paperTowelDispensersPosition.length > 0) {
      error = create_error_1.createError({
        msg: "Can't assign any Position for a paper towel cut out if it's set to false.",
        code: 'NOT_ASSIGNABLE',
        inObject: 'builtInParts.paperTowelDispensersPosition',
        statusCode: 400
      });
      return error;
    }
  }

  if (builtInParts && builtInParts.paperTowelDispensersPosition && builtInParts.paperTowelDispensersPosition.length > 0) {
    if (!plateBuilder) {
      error = create_error_1.createError({
        msg: "Platebuilder not provided.",
        code: 'NOT_ASSIGNABLE',
        inObject: 'builtInParts.paperTowelDispensersPosition',
        statusCode: 400
      });
      return error;
    }

    var cutOuts = cut_outs_1.cutOuts(conf);
    var dispensersType_1 = 'PROVIDER';
    var selectedType = lodash_1.find(cutOuts, function (type) {
      return type.key === dispensersType_1;
    });

    if (!selectedType) {
      error = create_error_1.createError({
        msg: "Selected cutout not found.",
        code: 'NOT_ASSIGNABLE',
        inObject: 'builtInParts.paperTowelDispensersPosition',
        statusCode: 400
      });
      return error;
    }

    var cutoutElement = plateBuilder.elementsBuilder.buildCutOut({}, selectedType);
    var distances = plateBuilder.calc.spacePositions(cutoutElement, null, false);
    var spacings = plateBuilder.calc.spaceSizes(cutoutElement, distances);
    var positions = builtInParts.paperTowelDispensersPosition;

    if (positions.length !== spacings.length) {
      error = create_error_1.createError({
        msg: "Spacings and positions don't match.",
        code: 'NOT_ASSIGNABLE',
        inObject: 'builtInParts.paperTowelDispensersPosition',
        statusCode: 400
      });
    }

    var isEnabled_1 = [];
    var reqWidth_1 = cutoutElement.outerWidth;
    spacings.forEach(function (spacing, index) {
      var hasSpace = spacing >= reqWidth_1;
      isEnabled_1.push(hasSpace);
    });
    defaults.paperTowelDispensersPosition = lodash_1.assign({}, defaults.paperTowelDispensersPosition, {
      isEnabled: isEnabled_1,
      reqWidth: reqWidth_1,
      spacings: spacings,
      distances: distances
    });
  }

  return error ? error : defaults;
};

exports.validateTissueDispenserPosition = function (builtInParts, defaults, consoles, plateBuilder, apronHeight) {
  var error;

  if (builtInParts.tissueDispenser === false) {
    if (builtInParts.tissueDispenserPosition && builtInParts.tissueDispenserPosition.length > 0) {
      error = create_error_1.createError({
        msg: "Can't assign any position for a tissue dispenser if tissue dispenser is set to false.",
        code: 'NOT_ASSIGNABLE',
        inObject: 'builtInParts.tissueDispensersPosition',
        statusCode: 400
      });
      return error;
    }
  }

  if (builtInParts && builtInParts.tissueDispenserPosition) {
    if (!plateBuilder) {
      error = create_error_1.createError({
        msg: "Platebuilder not provided.",
        code: 'NOT_ASSIGNABLE',
        inObject: 'builtInParts.tissueDispensersPosition',
        statusCode: 400
      });
      return error;
    }

    var tissueDispenserElement = plateBuilder.elementsBuilder.buildTissueDispenser();
    var distances = plateBuilder.calc.spacePositions(tissueDispenserElement, null, false);
    var spacings = plateBuilder.calc.spaceSizes(tissueDispenserElement, distances);
    var positions = builtInParts.tissueDispenserPosition;

    if (positions.length !== spacings.length) {
      error = create_error_1.createError({
        msg: "Spacings and positions don't match.",
        code: 'NOT_ASSIGNABLE',
        inObject: 'builtInParts.tissueDispensersPosition',
        statusCode: 400
      });
    }

    var isEnabled_2 = [];
    var reqWidth_2 = tissueDispenserElement.outerWidth; // console.log('tissue spacings', spacings);
    // console.log('tissue reqWidth', tissueDispenserElement.outerWidth);

    spacings.forEach(function (spacing, index) {
      var hasSpace = spacing >= reqWidth_2;
      var reqApronMin = 150;
      var reqApronMax = 150;
      var hasApron = (apronHeight || 0) >= reqApronMin && (apronHeight || 0) <= reqApronMax;
      isEnabled_2.push(hasSpace && hasApron);
    });
    defaults.tissueDispenserPosition = lodash_1.assign({}, defaults.tissueDispenserPosition, {
      isEnabled: isEnabled_2,
      reqWidth: reqWidth_2,
      spacings: spacings,
      distances: distances
    });
  }

  return error ? error : defaults;
};

exports.transformStringToBoolean = function (defaults) {
  var newDefaults = [];
  defaults.map(function (def) {
    if (def === 'left' || def === 'right') {
      newDefaults.push(def === 'left' ? true : def === 'right' ? false : false);
    } else {
      newDefaults.push(def);
    }
  });
  return newDefaults;
};

exports.validateBuiltInParts = {
  validateCutOutDisposalsPosition: exports.validateCutOutDisposalsPosition,
  validatePaperTowelDispensersPosition: exports.validatePaperTowelDispensersPosition,
  validateTapHole: exports.validateTapHole,
  validateTissueDispenserPosition: exports.validateTissueDispenserPosition
};
exports.default = exports.validateBuiltInParts;